/**
 * External Imports
 */
import { FC, useEffect, useState } from 'react';

import { useLocation, useNavigate, useParams } from 'react-router-dom';

/**
 * Internal Imports
 */
import EmployeeProfileHeader from '../../components/profileHeaders/employeeProfileHeader';
import Round from '../../components/round/Round';
import Loading from '../../components/shared/Loading';
import HistorySideNav from '../../components/sideNav/historySideNav';
import HistorySideDrawer from '../../components/sideNav/historySideDrawer';

import {
  useGetEmployeeNotesQuery,
  useGetEmployeeToRoundQuery
} from '../../redux/apis/Employees.api';
import { useGetEmployeeRoundHistoryQuery } from '../../redux/apis/Reports.api';

/**
 * Global Type Definition Imports
 */

/**
 * Style Imports
 */
import { ProfileContainer } from './styles/Validation.styles';

const ValidationProfile: FC = () => {
  const [selectedTab, setSelectedTab] = useState<string>('');

  const { state } = useLocation();
  const { validationType = '' } = useParams();
  const roundType =
    validationType === 'aidet'
      ? 'aidetValidation'
      : validationType === 'bssr'
      ? 'bssrValidation'
      : validationType === 'safety'
      ? 'safetyValidation'
      : 'validation';
  const navigate = useNavigate();
  const { employeeId = '' } =
    (state as {
      employeeId: string;
    }) || {};

  const {
    data: employeeToRoundData,
    // isError: isGetEmployeeToRoundError,
    isFetching: isGetEmployeeToRoundFetching
    // isLoading: isGetEmployeeToRoundLoading
  } = useGetEmployeeToRoundQuery(employeeId, {
    refetchOnMountOrArgChange: true,
    skip: !employeeId
  });
  const {
    data: employeeNotesData,
    // isError: isGetEmployeeNotesError,
    // isFetching: isGetEmployeeNotesFetching
    isLoading: isGetEmployeeNotesLoading
  } = useGetEmployeeNotesQuery(employeeId, {
    pollingInterval: 60000,
    refetchOnMountOrArgChange: true,
    skip: !employeeToRoundData?.employeeId
  });

  const {
    data: employeeRoundHistory,
    isLoading: isGetEmployeeRoundHistoryLoading
  } = useGetEmployeeRoundHistoryQuery(
    {
      employeeId: employeeToRoundData?.hcaid,
      roundingTypes: [roundType]
    },
    {
      skip: !employeeToRoundData?.hcaid,
      refetchOnMountOrArgChange: true,
      refetchOnFocus: true,
      refetchOnReconnect: true
    }
  );

  useEffect(() => {
    if (!employeeId && !employeeToRoundData) {
      navigate(window.localStorage.getItem('orbitLastPath') ?? '/');
    }
  }, [employeeId, employeeToRoundData]);

  // TODO: Do we need to have historic panel open by default for validation rounds?
  // useEffect(() => {
  //   const roundCount = employeeRoundHistory?.length ?? 0;
  //   if (roundCount > 0) {
  //     setSelectedTab('pastRounds');
  //   }
  // }, [employeeRoundHistory]);

  return (
    <ProfileContainer
      className="neu-bg-plain-0"
      data-testid="validation-profile-view"
    >
      {isGetEmployeeToRoundFetching ||
      isGetEmployeeNotesLoading ||
      isGetEmployeeRoundHistoryLoading ? (
        <Loading centered label="subject data..." />
      ) : (
        <>
          <section>
            <EmployeeProfileHeader selectedEmployee={employeeToRoundData} />
          </section>
          <section className="d-flex" style={{ height: 'calc(100vh - 163px)' }}>
            <HistorySideNav
              selectedEmployee={{
                ...employeeToRoundData,
                notes: employeeNotesData || []
              }}
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
              type="validation"
              supportType={validationType}
            />
            <HistorySideDrawer
              selectedTab={selectedTab}
              selectedPerson={{
                ...employeeToRoundData,
                notes: employeeNotesData || []
              }}
              roundHistory={employeeRoundHistory}
              tasks={[]}
              type="validation"
              supportType={validationType}
              setSelectedTab={setSelectedTab}
            />
            <Round type={roundType} selectedEmployee={employeeToRoundData} />
          </section>
        </>
      )}
    </ProfileContainer>
  );
};

export default ValidationProfile;
